import { registerTourPage } from '@/composables/tour/tourRegistry';
import { introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-timetable', {
  key: 'admin-timetable',
  label: 'Timetable',
  getSteps: () => [
    introStep({
      title: 'Timetable',
      content:
        '"Class Schedule" is where you assign subjects to time slots for each class. "Staff Workload" shows you how busy each staff member is, so you can spot conflicts. "Configuration" defines the periods, days, and templates the schedule is built on.',
    }),
  ],
});
